
import _util from '../../utils';

const UpdateLoggerService = {
    selectUpdateLogger(params, resolve, reject) {
        _util.request({
            url: '/api/HRSystemUpdateLog/Get',
            params: params,
            success: resolve,
            error: reject
        })      
    },
    createUpdateLogger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSystemUpdateLog/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateUpdateLogger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSystemUpdateLog/Put',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
	deleteUpdateLogger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSystemUpdateLog/BatchDelete',
			method: "delete",
			data: data,
			success: resolve,
			error: reject
		})
	},
	closeUpdateLog(data, resolve, reject) {
		_util.request({
			url: '/api/HRSystemUpdateLog/Close',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
  
}

export default UpdateLoggerService;



// WEBPACK FOOTER //
// ./src/services/SystemSetting/update-logger-service.js